module.exports = __webpack_public_path__ + "static/img/ikonaCwiczenie-OFF.6890df10.png";